import {
  Button,
  createStyles,
  Modal,
  stylize,
  Theme,
  WithStyles,
} from "@envestnet/envreact-component-library";
import { faWarning } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import withIntl from "utils/withIntl";
import messages from "./messages";

type Props = {
  dialogContent: string;
  counter: any;
  open: boolean;
  setAppIdle: Function;
  logout: Function;
  classes: any;
  isSessionExpired: boolean;
  formatMessage: Function;
};

const styles = (theme: Theme) =>
  createStyles({
    sessionTimeoutModal: {
      width: "376px",
    },
    sessionTimeoutHeader: {
      ...theme.fonts.h3,
      color: theme.colors.textDefault,
      fontFamily: "Red Hat Display !important",
      marginTop: "8px",
    },
    sessionTimeoutWarningIcon: {
      color: theme.colors.caution,
      fontSize: "36px",
    },
    sessionTimeoutContent: {
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
      fontFamily: "Red Hat Text !important",
      marginTop: "8px",
    },
    sessionExpiredIcon: {
      color: theme.colors.error,
      fontSize: "36px",
    },
    buttonContainer: {
      marginTop: "32px",
      display: "flex",
      justifyContent: "space-between",
    },
    modalButtons: {
      borderRadius: 0,
      fontFamily: "Red Hat Display !important",
    },
  });

const SessionTimeoutDialog = (props: Props & WithStyles<typeof styles>) => {
  const {
    dialogContent,
    counter,
    open,
    setAppIdle,
    logout,
    classes,
    isSessionExpired,
    formatMessage,
  } = props;

  const continueWorking = () => {
    clearInterval(counter);
    setAppIdle(false);
  };

  const redirectToDashboard = () => {
    clearInterval(counter);
    logout();
  };

  const getTimeoutWarningDialog = () => (
    <div className={classes.sessionTimeoutModal}>
      <FontAwesomeIcon
        className={classes.sessionTimeoutWarningIcon}
        icon={faWarning}
      />
      <div className={classes.sessionTimeoutHeader}>
        {formatMessage(messages.sessionExpiringSoon)}
      </div>
      <div className={classes.sessionTimeoutContent}>
        {formatMessage(messages.sessionExpiringSoonContent, {
          dialogContent,
        })}
      </div>
      <div className={classes.buttonContainer}>
        <div></div>
        <div>
          <Button
            buttonStyle="secondary"
            name={formatMessage(messages.signOut)}
            onClick={redirectToDashboard}
            className={classes.modalButtons}
            aria-label="Sign out button"
          />
          <Button
            buttonStyle="primary"
            name={formatMessage(messages.keepWorking)}
            onClick={continueWorking}
            style={{ marginLeft: "8px" }}
            className={classes.modalButtons}
            aria-label="Keep working button"
          />
        </div>
      </div>
    </div>
  );
  const getSessionExpiredDialog = () => (
    <div className={classes.sessionTimeoutModal}>
      <FontAwesomeIcon
        className={classes.sessionExpiredIcon}
        icon={faWarning}
      />
      <div className={classes.sessionTimeoutHeader}>
        {formatMessage(messages.sessionExpired)}
      </div>
      <div className={classes.sessionTimeoutContent}>
        {formatMessage(messages.sessionExpiredContent)}
      </div>
      <div className={classes.buttonContainer}>
        <div></div>
        <Button
          buttonStyle="primary"
          name={formatMessage(messages.signIn)}
          onClick={redirectToDashboard}
          className={classes.modalButtons}
          aria-label="Sign in button"
        />
      </div>
    </div>
  );
  return (
    <Modal
      open={open}
      onClose={isSessionExpired ? redirectToDashboard : continueWorking}
      contentContainerStyle={{
        borderRadius: 0,
      }}
    >
      {isSessionExpired ? getSessionExpiredDialog() : getTimeoutWarningDialog()}
    </Modal>
  );
};

export default withIntl(stylize<Props>(styles)(SessionTimeoutDialog));
